//@vendors
const React = require('react');
const { Form } = require('react-redux-form');
const { bindActionCreators } = require('redux');
const { connect } = require('react-redux');
const validator = require('validator');
//@actions
const formActions = require('react-redux-form').actions;
const stepsActions = require('actions/stepsActions');
//@utilities
import { formatText } from 'core/i18n';
//@components
const { InputText } = require('components/inputText/inputText');
const { SignaturePattern } = require('components/changeDataAC/signaturePattern/signaturePattern');

export class ItemEmailContent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showComponentSignaturePattern: false,
            newEmail: '',
            confirmEmail: '',
            disabled: true,
        };

        this.buildAddOrSaveButton = this.buildAddOrSaveButton.bind(this);
        this.buildCancelButton = this.buildCancelButton.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.onHandleChangeNewEmail = this.onHandleChangeNewEmail.bind(this);
        this.onHandleChangeConfirmEmail = this.onHandleChangeConfirmEmail.bind(this);
        this.toogleDisabled = this.toogleDisabled.bind(this);
        this.handleSuccess = this.handleSuccess.bind(this);
        this.handleValidateValidFields = this.handleValidateValidFields.bind(this);
        this.handleCompleteFields = this.handleCompleteFields.bind(this);
        this.validateSameEmail = this.validateSameEmail.bind(this);
    }

    UNSAFE_componentWillMount() {
        this.props.formActions.change('userProfile.newEmail', '');
        this.props.formActions.change('userProfile.confirmEmail', '');
    }

    buildAddOrSaveButton() {
        let buttonText = 'Modificar';
        return (
            <button type="submit" className="form__button form__button-primaryB">
                {buttonText}
            </button>
        );
    }

    handleValidateValidFields() {
        const { formActions, userProfileForm } = this.props;

        const requiredFields = ['newEmail', 'confirmEmail'];
        const requiredFlag = requiredFields.some(field => !userProfileForm[field].valid);

        if (requiredFlag) {
            requiredFields.forEach(field => {
                if (!userProfileForm[field].valid) {
                    formActions.setValidity(`userProfile.${field}`, { required: false });
                }
            });
        }

        return !requiredFlag;
    }

    handleCompleteFields() {
        const { formActions, userProfileForm } = this.props;

        const requiredFields = ['newEmail', 'confirmEmail'];
        const requiredFlag = requiredFields.some(field => userProfileForm[field].value === '');

        if (requiredFlag) {
            requiredFields.forEach(field => {
                if (userProfileForm[field].value === '') {
                    formActions.setValidity(`userProfile.${field}`, { required: false });
                }
            });
        }

        return !requiredFlag;
    }

    handleSubmit() {
        const isValid = this.handleValidateValidFields();
        const isComplete = this.handleCompleteFields();
        if (isValid && isComplete) {
            this.setState({
                showComponentSignaturePattern: true,
            });
        }
    }

    buildCancelButton() {
        return (
            <button type="button" className="form__button form__button-negativeB" onClick={this.handleCancel}>
                {formatText('button-cancel')}
            </button>
        );
    }

    handleCancel() {
        const { formActions, actions } = this.props;
        actions.validationAlreadyClientReset();
        this.props.onCancel();
        formActions.resetValidity('userProfile');
        this.setState({
            newEmail: '',
            confirmEmail: '',
        });
    }

    handleSuccess() {
        this.props.onSuccess();
    }

    onHandleChangeNewEmail(e) {
        const { formActions, actions } = this.props;
        if (e.target.value == '' || e.target.value != this.state.newEmail) {
            this.setState({ confirmEmail: '' });
            this.toogleDisabled(true);
            formActions.reset('userProfile.confirmEmail');
            actions.validationAlreadyClientReset();
        }
        this.setState({
            newEmail: e.target.value,
        });
    }

    toogleDisabled(value) {
        this.setState({
            disabled: value,
        });
    }

    onHandleChangeConfirmEmail(e) {
        this.setState({ confirmEmail: e.target.value });
    }

    validateSameEmail(email) {
        const { actions, userProfile } = this.props;
        const operationType = 'MODIFY_EMAIL';
        const toogleDisabled = this.toogleDisabled;

        actions.validateSameDataAlreadyClient(operationType, email, userProfile.accessToken, res => {
            if (res) {
                toogleDisabled(false);
            }
        });
    }

    render() {
        const { userProfile, userProfileForm, immAlreadyClient } = this.props;
        const cancelButton = this.buildCancelButton();
        const saveButton = this.buildAddOrSaveButton();
        const validateSameEmail = this.validateSameEmail;
        const toogleDisabled = this.toogleDisabled;
        let data = { email: this.state.confirmEmail };
        let error = '';
        if (immAlreadyClient.get('isValidated') && immAlreadyClient.get('error')) {
            error = formatText('changeData-sameEmailError');
        }
        let classInput = error ? 'inner-form__email-input--error' : 'inner-form__email-input';

        const modifyEmail = (
            <div className="changeData">
                <div className="inner-form">
                    <Form id="formChangeData" model="userProfile" onSubmit={this.handleSubmit}>
                        <div className="title-box__title--blue">
                            <label>{formatText('changeData-modifyEmail')}</label>
                        </div>
                        <div className="change-data__subtitle__margin">
                            <span>{formatText('changeData-tip')}</span>
                        </div>
                        <div className="change-data__subtitle">
                            <label>Email actual</label>
                            <p>{userProfile.email}</p>
                        </div>
                        <div className="row form__input md-form-group">
                            <div className="col-sm-6">
                                <label>{formatText('changeData-newEmail')}</label>
                                <InputText
                                    profileModel={'userProfile.newEmail'}
                                    type="email"
                                    id="newEmail"
                                    inputClass={classInput}
                                    name="newEmail"
                                    placeholder="Ingresa el email"
                                    value={this.state.newEmail}
                                    onChange={this.onHandleChangeNewEmail}
                                    validations={{
                                        required: value => {
                                            if (value && value.length) {
                                                return value && value.length;
                                            }
                                        },
                                        valid: value => {
                                            if (!validator.isEmail(value)) {
                                                return false;
                                            }
                                            return true;
                                        },
                                    }}
                                    messagesError={{
                                        required: formatText('changeData-required'),
                                        valid: value => {
                                            let message;
                                            if (!validator.isEmail(value)) {
                                                message = formatText('changeData-invalidEmail');
                                            }
                                            return message;
                                        },
                                    }}
                                    isValidated={function () {
                                        const newEmail = document.getElementById('newEmail').value;
                                        validateSameEmail(newEmail);
                                    }}
                                    isNotValidated={function () {
                                        toogleDisabled(true);
                                    }}
                                    userProfileForm={userProfileForm}
                                    userProfile={userProfile}
                                    formActions={formActions}
                                    {...this.props}
                                />
                                <p className="form__field_error">{error}</p>
                            </div>
                            <div className="col-sm-6">
                                <label>{formatText('changeData-repeatEmail')}</label>
                                <InputText
                                    profileModel={'userProfile.confirmEmail'}
                                    type="email"
                                    id="confirmEmail"
                                    inputClass="inner-form__email-input"
                                    name="confirmEmail"
                                    placeholder="Ingresa el email"
                                    value={this.state.confirmEmail}
                                    onChange={this.onHandleChangeConfirmEmail}
                                    validations={{
                                        required: value => {
                                            return value && value.length;
                                        },
                                        valid: value => {
                                            const newEmail = document.getElementById('newEmail');
                                            if (!validator.isEmail(value) || newEmail.value !== value) {
                                                return false;
                                            }
                                            return true;
                                        },
                                    }}
                                    messagesError={{
                                        required: formatText('changeData-required'),
                                        valid: value => {
                                            let message;
                                            const newEmail = document.getElementById('newEmail');
                                            if (!validator.isEmail(value)) {
                                                message = formatText('changeData-invalidEmail');
                                            } else if (value !== newEmail.value) {
                                                message = formatText('changeData-differentEmailError');
                                            }
                                            return message;
                                        },
                                    }}
                                    userProfileForm={userProfileForm}
                                    userProfile={userProfile}
                                    formActions={formActions}
                                    disabled={this.state.disabled}
                                    {...this.props}
                                />
                            </div>
                        </div>
                        <hr className="no-mrg-top" />
                        <div className="inner-form__footer">
                            <div className="inner-form__footer--buttons">
                                {cancelButton}
                                {saveButton}
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        );
        return (
            <div>
                {this.state.showComponentSignaturePattern ? (
                    <SignaturePattern
                        onSuccess={this.handleSuccess}
                        onCancel={this.handleCancel}
                        data={data}
                        operationType={'modify_email'}
                    />
                ) : (
                    modifyEmail
                )}
            </div>
        );
    }
}

module.exports.ItemEmailContent = connect(
    state => ({
        userProfile: state.userProfile,
        userProfileForm: state.userProfileForm,
        immAlreadyClient: state.alreadyClientData,
    }),
    dispatch => ({
        actions: bindActionCreators(stepsActions, dispatch),
        formActions: bindActionCreators(formActions, dispatch),
    })
)(ItemEmailContent);
